export default __webpack_public_path__ + "static/defaultCover-d55e36e7f707fb1143cd5036442d776f.png";